import React from "react";
import logo from "./icons/abc.png";
import "../Components/Footer.css";
function Footer() {
  return (
    <div className="footer-main" id="footer">
      <div className="ab-ab">
         
        <div className="endfooter">
          <div className="end-footer-real">
            {/* <img className='logo-footer' src={logo} /> */}
            <p className="abcd">© 2026 Tech Trends. All Rights Reserved</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
